import { Socket } from 'phoenix'
import { LiveSocket } from 'phoenix_live_view'
import { createApp } from 'vue'
import AppRoot from './AppRoot'
import harness from './harness'
import bootstrap from './bootstrap'
import { preloadFullV7WhenIdle } from './icons/v7Registry'

let csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute('content')
let liveSocket = new LiveSocket('/live', Socket, { params: { _csrf_token: csrfToken } })

liveSocket.connect()

window.liveSocket = liveSocket

// Vue 3 inverts the Vue 2 order: the app is created from the root component and
// then configured, rather than configuring a global constructor and building the
// root from it. `harness` and `bootstrap` now take the app instance.
const app = createApp(AppRoot)

harness(app)

const { router } = bootstrap(app)

// Router 4 replaces onReady() with isReady(). Mounting only once the initial
// navigation has resolved keeps the first paint from flashing the wrong route.
router.isReady().then(() => {
  app.mount('#vue-container')
  preloadFullV7WhenIdle()
})
